import { BrowserRouter, Route, Routes } from "react-router-dom";

import Order from "./pages/Order";
import Data from "./pages/Data";
import Shipping from "./pages/Shipping";
import Devolution from "./pages/Devolution";
import Login from "./pages/Login";
import Follow from "./pages/follow";
import Start from "./pages/Start";
import SelectedProducts from "./pages/Order/selectedProducts";
import InfoData from "./pages/InfoData/Index";

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Start />} />
        <Route path="/login" element={<Login />} />
        <Route path="/order" element={<Order />} />
        <Route path="/products" element={<SelectedProducts />} />
        <Route path="/data" element={<Data />} />
        <Route path="/shipping" element={<Shipping />} />
        <Route path="/devolution" element={<Devolution />} />
        <Route path="/follow" element={<Follow />} />
        <Route path="/info" element={<InfoData />} />
        {/* <Route path="/solicitar" element={<Start />} /> */}
        {/* <Route path="/login-acompany" element={<LoginAcompany />} /> */}
      </Routes>
    </BrowserRouter>
  );
}
export default AppRoutes;
